/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWishlistProductsQueryVariables = Exact<{
  companyId: string;
  role_assignment_id: string;
}>;


export type GetWishlistProductsQuery = { getWishlistProducts: { items: Array<{ id: string, supplier_id: string, sku: number, created_at: string }> } | null };


export const GetWishlistProductsDocument = /*#__PURE__*/ gql`
    query GetWishlistProducts($companyId: uuid!, $role_assignment_id: uuid!) {
  getWishlistProducts(
    companyId: $companyId
    role_assignment_id: $role_assignment_id
  ) {
    items {
      id
      supplier_id
      sku
      created_at
    }
  }
}
    `;

/**
 * __useGetWishlistProductsQuery__
 *
 * To run a query within a React component, call `useGetWishlistProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWishlistProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWishlistProductsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      role_assignment_id: // value for 'role_assignment_id'
 *   },
 * });
 */
export function useGetWishlistProductsQuery(baseOptions: Apollo.QueryHookOptions<GetWishlistProductsQuery, GetWishlistProductsQueryVariables> & ({ variables: GetWishlistProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>(GetWishlistProductsDocument, options);
      }
export function useGetWishlistProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>(GetWishlistProductsDocument, options);
        }
// @ts-ignore
export function useGetWishlistProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>;
export function useGetWishlistProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWishlistProductsQuery | undefined, GetWishlistProductsQueryVariables>;
export function useGetWishlistProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>(GetWishlistProductsDocument, options);
        }
export type GetWishlistProductsQueryHookResult = ReturnType<typeof useGetWishlistProductsQuery>;
export type GetWishlistProductsLazyQueryHookResult = ReturnType<typeof useGetWishlistProductsLazyQuery>;
export type GetWishlistProductsSuspenseQueryHookResult = ReturnType<typeof useGetWishlistProductsSuspenseQuery>;
export type GetWishlistProductsQueryResult = Apollo.QueryResult<GetWishlistProductsQuery, GetWishlistProductsQueryVariables>;